import React from "react";
import { Mic, Activity, PhoneIncoming, CircleCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheMollyCallSolution() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-mollycall-solution" ref={ref} className={`w-full overflow-hidden bg-background transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="grid min-h-[700px] w-full grid-cols-1 lg:grid-cols-5">
        {}
        <div className="relative flex items-center justify-center bg-muted/20 lg:col-span-3 overflow-hidden">
          {}
          <div className="absolute inset-0 z-0">
            <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572085/img/office_blur_professional.png)] bg-cover bg-center opacity-90 blur-[2px] transition-transform duration-1000 hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-r from-background/20 to-background/5" />
          </div>

          {}
          <div className="relative z-10 w-full max-w-md px-6">
            <Card className="border-white/20 bg-white/70 shadow-2xl backdrop-blur-xl dark:bg-black/60 dark:border-white/10">
              <CardContent className="p-6">
                {}
                <div className="mb-6 flex items-center justify-between border-b border-black/5 pb-4 dark:border-white/10">
                  <div className="flex items-center gap-3">
                    <div className="flex size-10 items-center justify-center rounded-full bg-primary/10 text-primary">
                      <Mic className="size-5" />
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground">
                        MollyCall Agent
                      </h3>
                      <p className="text-xs text-muted-foreground">
                        Active • Listening
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="relative flex size-2.5">
                      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75"></span>
                      <span className="relative inline-flex size-2.5 rounded-full bg-green-500"></span>
                    </span>
                    <span className="text-xs font-medium text-green-600 dark:text-green-400">
                      Live
                    </span>
                  </div>
                </div>

                {}
                <div className="mb-6 space-y-4">
                  <div className="flex items-center justify-between gap-1">
                    {[...Array(12)].map((_, i) => <div key={i} data-index={i} className="h-8 w-1.5 rounded-full bg-primary/80 transition-all duration-500 ease-in-out animate-pulse" style={{
                    height: `${Math.max(20, Math.random() * 100)}%`,
                    animationDelay: `${i * 0.1}s`
                  }} />)}
                  </div>
                  <div className="flex items-center justify-between rounded-lg bg-background/50 p-3">
                    <div className="flex items-center gap-3">
                      <PhoneIncoming className="size-4 text-muted-foreground" />
                      <span className="text-sm font-medium text-foreground">
                        Incoming Call: +1 (555) 012-3456
                      </span>
                    </div>
                    <span className="text-xs text-muted-foreground">00:14</span>
                  </div>
                </div>

                {}
                <div className="space-y-3">
                  <div className="flex items-center gap-3 text-sm text-muted-foreground">
                    <CircleCheck className="size-4 text-primary" />
                    <span>Intent recognized: Appointment Booking</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-muted-foreground">
                    <CircleCheck className="size-4 text-primary" />
                    <span>CRM Profile Synced</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-muted-foreground">
                    <Activity className="size-4 text-primary" />
                    <span>Checking availability...</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {}
        <div className="flex flex-col justify-center bg-background px-8 py-20 lg:col-span-2 lg:px-16 lg:py-0">
          <div className="max-w-lg">
            <div className="mb-6 inline-flex items-center rounded-full border border-primary/20 bg-primary/5 px-3 py-1 text-xs font-medium text-primary">
              Voice-First Philosophy
            </div>
            <h2 className="mb-6 text-4xl font-bold leading-tight tracking-tight text-foreground lg:text-5xl">
              The Human Touch, <br />
              <span className="text-primary">Perfected by AI.</span>
            </h2>
            <p className="mb-8 text-lg leading-relaxed text-muted-foreground">
              We believe the most powerful interface is the human voice. MollyCall
              doesn't just route calls; it understands context, emotion, and intent.
            </p>
            <p className="mb-10 text-base leading-relaxed text-muted-foreground">
              Our intelligent agents eliminate the friction of manual scheduling and
              missed opportunities, handling complex conversations with the fluidity
              of your best employee—available 24/7, instantly scalable, and always
              on brand.
            </p>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button asChild variant="outline" size="lg" className="group border-primary/20 text-primary hover:border-primary hover:bg-primary/5">
                <Link to="/SolutionsPage">
                  Explore Solutions
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}